module.exports = __webpack_public_path__ + "static/media/S4N6-3.492b1ea2.svg";